//#region recipes/notices/top_banner_info/top_banner_info_constants.js
var e = [
	"green300",
	"green100",
	"red200",
	"red100",
	"gold100",
	"gold200",
	"black100",
	"white"
], t = { COLOR_CODES: e };
//#endregion
export { e as COLOR_CODES, t as default };

//# sourceMappingURL=top-banner-info-constants.js.map